import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../../locales/translations';
export function useTexts() {
  const { t } = useTranslation(
    TranslationsKeys.ADMISSION_MANAGEMENT_ADMISSION_CALL,
  );

  return {
    subtitle: t('subtitle'),
    filters: {
      nameOrId: {
        label: t('filters.nameOrId.label'),
        placeholder: t('filters.nameOrId.placeholder'),
      },
      status: {
        label: t('filters.status.label'),
        placeholder: t('filters.status.placeholder'),
      },
      buttons: {
        search: t('filters.buttons.search'),
        clear: t('filters.buttons.clear'),
      },
    },
    callFunctionalityButtons: {
      individual: t('callFunctionalityButtons.individual'),
      download: {
        button: t('callFunctionalityButtons.download.button'),
        error: t('callFunctionalityButtons.download.error'),
      },
      massive: t('callFunctionalityButtons.massive'),
      notify: t('callFunctionalityButtons.notify'),
    },
    table: {
      title: t('table.title'),
      headers: {
        postulantIdentificationValue: t(
          `table.headers.postulantIdentificationValue`,
        ),
        postulantFistname: t(`table.headers.postulantFistname`),
        postulantLastname: t(`table.headers.postulantLastname`),
        postulantPhone: t(`table.headers.postulantPhone`),
        postulantEmail: t(`table.headers.postulantEmail`),
        callNumber: t(`table.headers.callNumber`),
        callStatus: t(`table.headers.callStatus`),
        action: t(`table.headers.action`),
      },
    },
  };
}
